// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentScopeTemplatesMetadataQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
}>;


export type DevelopmentScopeTemplatesMetadataQuery = { __typename?: 'Query', development: { __typename?: 'Development', id: string, readyPlans: Array<{ __typename?: 'ReadyPlan', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }>, costMappingProgress: { __typename?: 'CostMappingProgress', showCostMappingProgress: boolean, totalMappingsForDevelopment: number, totalScheduleTemplateItemMappings: number } } };

export type DevelopmentScopeTemplatesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ItemTemplateFilter>;
}>;


export type DevelopmentScopeTemplatesQuery = { __typename?: 'Query', itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, displayName: string, isVersioned: boolean, displayVersion: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], statusDetail: { __typename?: 'ItemTemplateStatusDetail', code: Types.ItemTemplateStatus, name: string }, hasCloneToTargets: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlan?: { __typename?: 'ReadyPlan', displayName: string, id: string, name: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string } } | null | undefined, canCreateNewVersion: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, basedOn?: { __typename?: 'ItemTemplate', id: string } | null | undefined }> };

export type DevelopmentScopeDevelopmentFragment = { __typename?: 'Development', id: string, readyPlans: Array<{ __typename?: 'ReadyPlan', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }>, costMappingProgress: { __typename?: 'CostMappingProgress', showCostMappingProgress: boolean, totalMappingsForDevelopment: number, totalScheduleTemplateItemMappings: number } };

export type DevelopmentScopeTemplateFragment = { __typename?: 'ItemTemplate', id: string, displayName: string, isVersioned: boolean, displayVersion: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], statusDetail: { __typename?: 'ItemTemplateStatusDetail', code: Types.ItemTemplateStatus, name: string }, hasCloneToTargets: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlan?: { __typename?: 'ReadyPlan', displayName: string, id: string, name: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string } } | null | undefined, canCreateNewVersion: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, basedOn?: { __typename?: 'ItemTemplate', id: string } | null | undefined };

export type ScopeTemplateOptionFragment = { __typename?: 'ReadyPlanOption', id: string, active: boolean, type: { __typename?: 'GlobalOptionType', id: string, name: string }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string, tags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }> } };

export const DevelopmentScopeDevelopmentFragmentDoc = gql`
    fragment DevelopmentScopeDevelopment on Development {
  id
  readyPlans {
    ...Named
    options {
      ...Named
    }
  }
  costMappingProgress {
    showCostMappingProgress
    totalMappingsForDevelopment
    totalScheduleTemplateItemMappings
  }
}
    ${NamedFragmentDoc}`;
export const DevelopmentScopeTemplateFragmentDoc = gql`
    fragment DevelopmentScopeTemplate on ItemTemplate {
  id
  displayName
  isVersioned
  displayVersion
  statusDetail {
    code
    name
  }
  createdAt
  updatedAt
  hasCloneToTargets {
    ...PotentialOperationDetails
  }
  readyPlan {
    ...Named
    displayName
    status {
      code
      name
    }
  }
  canCreateNewVersion {
    ...PotentialOperationDetails
  }
  canDelete {
    ...PotentialOperationDetails
  }
  basedOn {
    id
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${NamedFragmentDoc}`;
export const ScopeTemplateOptionFragmentDoc = gql`
    fragment ScopeTemplateOption on ReadyPlanOption {
  id
  active
  type {
    ...Named
  }
  location {
    ...Named
  }
  globalOption {
    id
    tags {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;
export const DevelopmentScopeTemplatesMetadataDocument = gql`
    query DevelopmentScopeTemplatesMetadata($developmentId: ID!) {
  development(id: $developmentId) {
    ...DevelopmentScopeDevelopment
  }
}
    ${DevelopmentScopeDevelopmentFragmentDoc}`;

/**
 * __useDevelopmentScopeTemplatesMetadataQuery__
 *
 * To run a query within a React component, call `useDevelopmentScopeTemplatesMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentScopeTemplatesMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentScopeTemplatesMetadataQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *   },
 * });
 */
export function useDevelopmentScopeTemplatesMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentScopeTemplatesMetadataQuery, DevelopmentScopeTemplatesMetadataQueryVariables> & ({ variables: DevelopmentScopeTemplatesMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentScopeTemplatesMetadataQuery, DevelopmentScopeTemplatesMetadataQueryVariables>(DevelopmentScopeTemplatesMetadataDocument, options);
      }
export function useDevelopmentScopeTemplatesMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentScopeTemplatesMetadataQuery, DevelopmentScopeTemplatesMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentScopeTemplatesMetadataQuery, DevelopmentScopeTemplatesMetadataQueryVariables>(DevelopmentScopeTemplatesMetadataDocument, options);
        }
// @ts-ignore
export function useDevelopmentScopeTemplatesMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentScopeTemplatesMetadataQuery, DevelopmentScopeTemplatesMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentScopeTemplatesMetadataQuery, DevelopmentScopeTemplatesMetadataQueryVariables>;
export function useDevelopmentScopeTemplatesMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentScopeTemplatesMetadataQuery, DevelopmentScopeTemplatesMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentScopeTemplatesMetadataQuery | undefined, DevelopmentScopeTemplatesMetadataQueryVariables>;
export function useDevelopmentScopeTemplatesMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentScopeTemplatesMetadataQuery, DevelopmentScopeTemplatesMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentScopeTemplatesMetadataQuery, DevelopmentScopeTemplatesMetadataQueryVariables>(DevelopmentScopeTemplatesMetadataDocument, options);
        }
export type DevelopmentScopeTemplatesMetadataQueryHookResult = ReturnType<typeof useDevelopmentScopeTemplatesMetadataQuery>;
export type DevelopmentScopeTemplatesMetadataLazyQueryHookResult = ReturnType<typeof useDevelopmentScopeTemplatesMetadataLazyQuery>;
export type DevelopmentScopeTemplatesMetadataSuspenseQueryHookResult = ReturnType<typeof useDevelopmentScopeTemplatesMetadataSuspenseQuery>;
export type DevelopmentScopeTemplatesMetadataQueryResult = ApolloReactCommon.QueryResult<DevelopmentScopeTemplatesMetadataQuery, DevelopmentScopeTemplatesMetadataQueryVariables>;
export const DevelopmentScopeTemplatesDocument = gql`
    query DevelopmentScopeTemplates($filter: ItemTemplateFilter) {
  itemTemplates(filter: $filter) {
    ...DevelopmentScopeTemplate
  }
}
    ${DevelopmentScopeTemplateFragmentDoc}`;

/**
 * __useDevelopmentScopeTemplatesQuery__
 *
 * To run a query within a React component, call `useDevelopmentScopeTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentScopeTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentScopeTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDevelopmentScopeTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DevelopmentScopeTemplatesQuery, DevelopmentScopeTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentScopeTemplatesQuery, DevelopmentScopeTemplatesQueryVariables>(DevelopmentScopeTemplatesDocument, options);
      }
export function useDevelopmentScopeTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentScopeTemplatesQuery, DevelopmentScopeTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentScopeTemplatesQuery, DevelopmentScopeTemplatesQueryVariables>(DevelopmentScopeTemplatesDocument, options);
        }
// @ts-ignore
export function useDevelopmentScopeTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentScopeTemplatesQuery, DevelopmentScopeTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentScopeTemplatesQuery, DevelopmentScopeTemplatesQueryVariables>;
export function useDevelopmentScopeTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentScopeTemplatesQuery, DevelopmentScopeTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentScopeTemplatesQuery | undefined, DevelopmentScopeTemplatesQueryVariables>;
export function useDevelopmentScopeTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentScopeTemplatesQuery, DevelopmentScopeTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentScopeTemplatesQuery, DevelopmentScopeTemplatesQueryVariables>(DevelopmentScopeTemplatesDocument, options);
        }
export type DevelopmentScopeTemplatesQueryHookResult = ReturnType<typeof useDevelopmentScopeTemplatesQuery>;
export type DevelopmentScopeTemplatesLazyQueryHookResult = ReturnType<typeof useDevelopmentScopeTemplatesLazyQuery>;
export type DevelopmentScopeTemplatesSuspenseQueryHookResult = ReturnType<typeof useDevelopmentScopeTemplatesSuspenseQuery>;
export type DevelopmentScopeTemplatesQueryResult = ApolloReactCommon.QueryResult<DevelopmentScopeTemplatesQuery, DevelopmentScopeTemplatesQueryVariables>;